<!-- Register route: path: '/org/:sub_level/:id/fund-collection/:type/receipt-consolidation-report', component: ReceiptConsolidationReport -->
<template>
    <div class="section text-center mt-4" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <template v-else>
        <div class="section pt-2">
            <div class="rcr-hero">
                <h3 class="rcr-hero-title mal-text">രസീത് കൺസോളിഡേഷൻ റിപ്പോർട്ട്</h3>
                <div class="rcr-hero-meta mal-text" v-if="zoneName">{{ zoneName }}</div>
            </div>
        </div>

        <div class="section pt-0 mt-2" v-if="!units.length">
            <div class="rcr-empty mal-text">ഡാറ്റ ലഭ്യമല്ല</div>
        </div>

        <div class="section pt-0 mt-2" v-for="unit in units" :key="unit.unit_id">
            <div class="rcr-card">
                <div class="rcr-unit-header">
                    <span class="rcr-unit-name">{{ unit.unit_name }}</span>
                    <span class="rcr-unit-total">₹{{ unit.unit_total.toFixed(0) }}</span>
                </div>

                <div class="rcr-book-row" v-for="book in unit.books" :key="book.book_number">
                    <div class="rcr-book-top">
                        <span class="rcr-book-no">
                            Book {{ book.book_number }}
                            <small v-if="book.receipt_from">({{ book.receipt_from }}–{{ book.receipt_to }})</small>
                        </span>
                        <span class="rcr-book-badge" :class="book.taken_back ? 'done' : 'pending'">
                            {{ book.taken_back ? 'തിരിച്ചെടുത്തു' : 'ബാക്കി' }}
                        </span>
                    </div>
                    <div class="rcr-book-holder mal-text" v-if="book.holder_name">
                        <ion-icon name="person-outline"></ion-icon> {{ book.holder_name }}
                    </div>
                    <div class="rcr-totals">
                        <span class="rcr-total-item"><ion-icon name="globe-outline" style="color:#16a34a;"></ion-icon> ₹{{ book.totals.online.toFixed(0) }}</span>
                        <span class="rcr-total-item"><ion-icon name="business-outline" style="color:#b45309;"></ion-icon> ₹{{ book.totals.office.toFixed(0) }}</span>
                        <span class="rcr-total-item"><ion-icon name="create-outline" style="color:#6c3483;"></ion-icon> ₹{{ book.totals.manual.toFixed(0) }}</span>
                        <span class="rcr-total-item rcr-total-all"><ion-icon name="wallet-outline" style="color:#1a418c;"></ion-icon> ₹{{ book.totals.total.toFixed(0) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </template>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import UserService from "@/services/user.service";
import AlertModel from "../layouts/AlertModel.vue";

export default {
    name: "ReceiptConsolidationReport",
    components: { AlertModel },
    data() {
        return {
            loading: true,
            zoneName: "",
            units: [],
            alert_type: "",
            alert_message: "",
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
            return;
        }
        this.$root.updateParent("രസീത് കൺസോളിഡേഷൻ റിപ്പോർട്ട്");
        this.loadReport();
    },
    methods: {
        showAlert(type, message) {
            this.alert_type = type;
            this.alert_message = message;
            this.$refs.alert_model.openModel();
        },
        loadReport() {
            this.loading = true;
            UserService.authPostRequest("receipt-book/take-back/receipt-consolidation-report", {
                zone_id: parseInt(this.$route.params.id, 10),
                fund_type: this.$route.params.type,
                year: new Date().getFullYear(),
            }).then((response) => {
                this.loading = false;
                if (response.data.status === "success") {
                    this.zoneName = response.data.data.zone ? response.data.data.zone.name : "";
                    this.units = response.data.data.units || [];
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            }).catch((error) => {
                this.loading = false;
                this.showAlert("Error", (error.response && error.response.data && error.response.data.message) || "ഡാറ്റ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല");
            });
        },
    },
};
</script>

<style scoped>
.rcr-hero {
    background: #fff;
    border-radius: 14px;
    padding: 18px;
    text-align: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.rcr-hero-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #1a418c;
}
.rcr-hero-meta {
    font-size: 0.85rem;
    color: #6c757d;
    margin-top: 4px;
}
.rcr-empty {
    text-align: center;
    color: #6c757d;
    padding: 20px 0;
}
.rcr-card {
    background: #fff;
    border-radius: 14px;
    padding: 14px 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.rcr-unit-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    margin-bottom: 8px;
    border-bottom: 1px solid #eef0f5;
}
.rcr-unit-name {
    font-size: 14px;
    font-weight: 800;
    color: #27173E;
}
.rcr-unit-total {
    font-size: 14px;
    font-weight: 800;
    color: #1a418c;
}
.rcr-book-row {
    padding: 10px 0;
    border-top: 1px solid #f3f4f8;
}
.rcr-book-row:first-of-type { border-top: none; }
.rcr-book-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.rcr-book-no {
    font-size: 13px;
    font-weight: 700;
    color: #27173E;
}
.rcr-book-no small {
    font-weight: 500;
    color: #6c757d;
}
.rcr-book-badge {
    font-size: 10.5px;
    font-weight: 700;
    border-radius: 20px;
    padding: 3px 8px;
    white-space: nowrap;
}
.rcr-book-badge.done { background: #eafaf1; color: #12a85a; }
.rcr-book-badge.pending { background: #fff5f5; color: #d9534f; }
.rcr-book-holder {
    font-size: 11.5px;
    color: #6c757d;
    margin-top: 3px;
    display: flex;
    align-items: center;
    gap: 4px;
}
.rcr-totals {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 6px;
}
.rcr-total-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 700;
    color: #475569;
}
.rcr-total-all { color: #1a418c; }
</style>
